export function isComponentHasError($comp):boolean {
  if (!$comp || !$comp[0].$el || typeof $comp[0].$el.querySelector !== 'function') return false;
  return !!$comp[0].$el.querySelector('.el-form-item.is-error');
}
